export default __webpack_public_path__ + "static/media/Design2.b485e255.svg";